import SettingFrame from "../../../../../components/@settings/SettingFrame"
import ListTasks from "../../../../../components/@schedulers/tasks/ListTasks";

import { routeTypes } from "../../../../../hooks/useSystemRoutes"

export default function TasksPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListTasks 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       